import React from 'react';
import PropTypes from 'prop-types';

import Logo from '../../../authorizedState/header/logo';

import { deleteAuthorizationJwtTokenFromLocalStorage, deleteAuthorizationRefreshTokenFromLocalStorage } from '../../../helpers/localStorageHelper';
import configureReduxStore from '../../../../core/configureReduxStore';
import './styles.scss';

const ErrorPanel = (props) => {
  const onRedirectClick = () => {
    deleteAuthorizationJwtTokenFromLocalStorage();
    deleteAuthorizationRefreshTokenFromLocalStorage();
    configureReduxStore.persistor.purge();
    props.setIsError(false);
  };

  return (
    <div className="error-panel-container">
      <Logo />
      <div className="error-panel">
        <h1 className="error-panel-header">
          Wystapił bład
        </h1>
        <div className="error-header-subtitle">
          Coś poszło nie tak, spróbuj ponownie lub zgłoś nam swój problem.
        </div>
        <If condition={props.errorMessage}>
          <span className="panel-separator" />
          <div className="error-panel-details">
            <h2 className="error-details-header">
              Szczegóły błędu:
            </h2>
            <div className="error-details-description">
              {props.errorMessage}
            </div>
          </div>
        </If>
        <button
          type="button"
          className="button return-error-button"
          title="Zapisz bez wysyłania"
          onClick={onRedirectClick}
        >
          Powrót do strony głównej
        </button>
      </div>
    </div>
  );
};

ErrorPanel.propTypes = {
  errorMessage: PropTypes.string,
  setIsError: PropTypes.func.isRequired,
};

ErrorPanel.defaultProps = {
  errorMessage: '',
};

export default ErrorPanel;
